// frontend/src/pages/ForgotPassword.js
import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Home.css'; // Reuse Home.css for consistent styling

// Use environment variable or fallback to settings.py's API_URL
const API_URL = process.env.REACT_APP_API_URL;

function ForgotPassword() {
  const [formData, setFormData] = useState({ email: '' });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const formRef = useRef(null);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({});
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${API_URL}/accounts/password_reset/`, formData, {
        withCredentials: true,
      });
      if (response.data.success) {
        setMessage('We’ve emailed you instructions for setting your password. Check your inbox or spam folder.');
        setFormData({ email: '' });
      }
    } catch (error) {
      setErrors(error.response?.data.errors || { all: ['Failed to send reset email. Please try again.'] });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient">
      <nav className="navbar">
        <Link to="/" className="logo-container nav-logo">
          <span className="se">SE</span><span className="middle">rra</span><span className="nd">ND</span>
        </Link>
        <div className="flex gap-4">
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/login" className="btn">Login</Link>
        </div>
      </nav>

      <section className="py-12 px-4 max-w-md mx-auto" ref={formRef}>
        <div className="modal-content">
          <h2 className="text-2xl font-semibold mb-4">Forgot Password</h2>
          <p className="mb-4">Enter the email address associated with your SErraND account to receive a password reset link.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="e.g., yourname@example.com"
              className="input"
              required
            />
            {errors.all && <p className="text-red-500">{errors.all[0]}</p>}
            {message && <p className="text-green-500">{message}</p>}
            <div className="flex justify-end gap-2">
              <button type="submit" className="btn btn-green" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <Link to="/" className="btn btn-red">Cancel</Link>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default ForgotPassword;
